import React from 'react';
import BuyerList from '../common_modules/components/buyers/BuyerList';
import BuyerOrderDetailList from '../common_modules/components/buyers/BuyerOrderDetailList';

export const BuyersList: React.FC = () => <BuyerList dashboardType="client" />;

export const BuyerOrderDetailPage: React.FC = () => <BuyerOrderDetailList dashboardType="client" />;
